"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayIcon = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../icons");
var themes_1 = require("../../../v2/themes");
/**
 * @component Renders an icon component with customizable size, color, weight, and click handler.
 *
 * - The props object containing the following properties:
 * @prop {keyof typeof icons} icon: The name of the icon to be rendered.
 * @prop {number} size: The size of the icon in pixels.
 * @prop {string} color: The color of the icon.
 * @prop {'bold' | 'regular'} weight: The weight of the icon font. Defaults to "bold".
 * @prop {function} onClick: Optional click handler for the icon.
 * @prop {CSSProperties} style: Optional additional styles to apply to the container div.
 * @return {ReactElement} The rendered icon component.
 */
var DisplayIcon = function (_a) {
    var icon = _a.icon, size = _a.size, _b = _a.color, color = _b === void 0 ? themes_1.colors.grey80 : _b, _c = _a.weight, weight = _c === void 0 ? "bold" : _c, onClick = _a.onClick, _d = _a.style, style = _d === void 0 ? {} : _d;
    var IconComp = icons_1.icons[icon];
    return (react_1.default.createElement("div", { style: __assign({ cursor: onClick ? "pointer" : "default", display: "flex" }, style), onMouseDown: onClick || undefined }, IconComp && react_1.default.createElement(IconComp, { size: size, color: color, weight: weight })));
};
exports.DisplayIcon = DisplayIcon;
